// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"image_placeholder__2SBMt","feature":"image_feature__poDHI","square":"image_square__4U3S4","poster":"image_poster__0OJhr","standard":"image_standard__tnJxa"};